import React, {Fragment, useState} from 'react';
import Button from "../UI/Button";
import Modal from "../UI/Modal";
import ListEdit from "../UI/ListEdit";
import ModalFormInputsContainer from "../UI/ModalFormInputsContainer";
import Box from "../UI/Box";
import {useUnattendedAccessTermsAcceptances} from "../../hooks/useUnattendedAccessTermsAcceptances";
import {convertToDisplayDateTime} from "../../utility/utility";

const UnattendedAccessTermsAcceptanceList = (props) => {
    const [viewingAcceptance, setViewingAcceptance] = useState(null);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const {customerUnattendedAccessTermsAcceptances, pagination} = useUnattendedAccessTermsAcceptances(page, pageSize, 0);

    const acceptanceList = customerUnattendedAccessTermsAcceptances.map((item, index) => ({
        ...item,
        rowId       : index,
        versionDisplay : `v${item.version}`,
        acceptedAt  : convertToDisplayDateTime(item.acceptedAt)
    }));

    const handleShowIconClick = (rowId) => {
        setViewingAcceptance(customerUnattendedAccessTermsAcceptances[rowId]);
    }

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const handlePageSizeChange = (pageSize) => {
        setPageSize(pageSize);
        setPage(1);
    };

    const listHeaders = [
        'Customer',
        'Version',
        'Accepted',
        'Actions'
    ];

    const columns = {
        functionParams : ['rowId'],
        dataKeys       : [
            'customerName',
            'versionDisplay',
            'acceptedAt'
        ],
    }

    return (
        <Fragment>
            <Box>
                <ListEdit
                    headers={listHeaders}
                    items={acceptanceList}
                    columns={columns}
                    pagination={pagination}
                    handleShowIconClick={handleShowIconClick}
                    handlePageChange={handlePageChange}
                    handlePageSizeChange={handlePageSizeChange}
                />
            </Box>
            {viewingAcceptance && (
                <Modal>
                    <ModalFormInputsContainer title={viewingAcceptance.customerName} onClose={() => setViewingAcceptance(null)}>
                        <p className="text-sm text-gray-500 mb-4">v{viewingAcceptance.version} &middot; {convertToDisplayDateTime(viewingAcceptance.acceptedAt)}</p>
                        <p className="whitespace-pre-wrap text-gray-700">{viewingAcceptance.textSnapshot}</p>
                    </ModalFormInputsContainer>
                    <div className="bg-gray-50 rounded-b-2xl px-6 py-4 flex justify-end">
                        <Button color="black" bgColor="white" title="Close" handleClick={() => setViewingAcceptance(null)}/>
                    </div>
                </Modal>
            )}
        </Fragment>
    );
}

export default UnattendedAccessTermsAcceptanceList;
